import { render, staticRenderFns } from "./PushDetail.vue?vue&type=template&id=23ca6095&scoped=true&"
import script from "./PushDetail.vue?vue&type=script&lang=js&"
export * from "./PushDetail.vue?vue&type=script&lang=js&"
import style0 from "./PushDetail.vue?vue&type=style&index=0&id=23ca6095&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca6095",
  null
  
)

export default component.exports